<template>
 <div class="container karty">
    <div class="card-deck flex-sm-column flex-md-row">
      <div class="card">
        <h5 class="card-title">Produkty</h5>
        <img
          class="card-img-top"
          src="./../assets/card1.jpg"
          alt="Card image cap"
        />
        <div class="card-body">
          <p
            class="card-text text-justify"
          >Zobacz nasze produkty w galerii zdjęć i&nbsp;dowiedz się dlaczego to właśnie nasze rozwiązania są najbardziej godne polecenia.</p>
        </div>
        <div class="card-footer d-flex justify-content-center">
          <b-button variant="primary" to="/produkty#produkty" class="btn btn-lg text-uppercase animated wow flipInX">Więcej</b-button>          
        </div>
      </div>
      <div class="card">
        <h5 class="card-title">Dokumentacja</h5>
        <img
          class="card-img-top"
          src="./../assets/card2.jpg"
          alt="Card image cap"
        />
        <div class="card-body">
          <p
            class="card-text text-justify"
          >Szczegółowa instrukcja obsługi i&nbsp;konserwacji urządzeń wraz z przykładami zastosowań. Uwagi eksploatacyjne i&nbsp;zapewnienia bezpieczeństwa. </p>
        </div>
        <div class="card-footer d-flex justify-content-center">
          <b-button variant="primary" to="/instrukcja#instrukcja" class="btn btn-lg text-uppercase animated wow flipInX" data-wow-delay="200ms">Więcej</b-button>          
        </div>
      </div>
      <div class="card">
        <h5 class="card-title">Cennik</h5>
        <img
          class="card-img-top"
          src="./../assets/card3.jpg"
          alt="Card image cap"
        />
        <div class="card-body">
          <p
            class="card-text text-justify"
          >Zapraszamy do zapoznania się z cennikiem oraz do kontaktu z nami. Z przyjemnością udzielimy odpowiedzi na Wasze pytania.</p>
        </div>
        <div class="card-footer d-flex justify-content-center">
          <b-button variant="primary" to="/kontakt#cennik" class="btn btn-lg text-uppercase animated wow flipInX" data-wow-delay="400ms">Więcej</b-button>          
        </div>
      </div>
    </div>
    <div class="spacer-30"></div>
  </div>
</template>

<script>
import sku from '@/sku.js';
// @ is an alias to /src

export default {
  name: 'Cards',
  components: {},
  mounted() {
    sku.equalizeHeight('.card-title')
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import 'node_modules/bootstrap/scss/variables';
.karty{
  margin-top: 100px;
}
.spacer-30{
  height:30px;
}
.card-body {
  padding-left: 0;
  padding-right: 0;
}
.btn-lg,
.btn-group-lg > .btn {
  font-size: 1rem;
  border: 0;
  padding: 10px 30px;
  margin-bottom: 50px;
}
h5.card-title {
  font-weight: bold;
  font-size: 38px;
  @media (min-width: map-get($grid-breakpoints, 'md') - 1) and (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    font-size:32px;
  }
}
.card-text {
  color: #777;
  line-height: 23px;
}
.card-footer{
  background: none;
}
</style>